<template>
  <div>
    <div v-if="!isOneVariable">
      <u>{{ label }}:</u>
    </div>
    <!-- <span> {{ fromValue }} to {{ toValue }} </span> -->
    <span>{{ toValue }} </span>
  </div>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeSlider',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    isOneVariable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // fromValue: function () {
    //   return this.valueWithPrefixAndSuffix(parseInt(this.value[0]));
    // },
    toValue: function () {
      return this.valueWithPrefixAndSuffix(parseInt(this.value[1]));
    },
    label: function () {
      return this.variable.short_label || this.variable.input_label;
    },
  },
  methods: {
    formattedValue: function (value) {
      const nf = new Intl.NumberFormat('en-US');
      return nf.format(value);
    },
    valueWithPrefixAndSuffix: function (value) {
      return `${this.variable.prefix || ''}${this.formattedValue(value)}${
        this.variable.suffix || ''
      }`;
    },
  },
};
</script>

<style scoped />
